export default {"src":"/_next/static/media/handshake.1260632f.svg","height":31,"width":50,"blurWidth":0,"blurHeight":0};